// extracted by mini-css-extract-plugin
module.exports = {"Dlight_Uganda_Data_Form_Field_Wrapper":"DlightUgandaDataDetail_Dlight_Uganda_Data_Form_Field_Wrapper__1CYEr"};